export const configurationConstants = {
    SUCCESS: 'CONFIGURATION_SUCCESS',
    ERROR: 'CONFIGURATION_ERROR', 
    IS_LPX_IN_MAINTENANCE_SUCCESS: "IS_LPX_IN_MAINTENANCE_SUCCESS",
    IS_LPX_IN_MAINTENANCE_ERROR: "IS_LPX_IN_MAINTENANCE_SUCCESS",
};
